import { defineStore } from 'pinia';
import { axios } from '@boot/axios.js';

export const useCausesStore = defineStore('causes', {
    state: () => ({
        causes: {}
    }),
    getters: {
        getCause(state) {
            return id => {
                if (id in state.causes) {
                    return state.causes[id];
                } else {
                    return null;
                }
            };
        }
    },
    actions: {
        /**
         * Resets the state to its default values.
         */
        resetState() {
            this.$reset();
        },

        /*
         * Load cause from server.
         */
        async loadCauseAction(causeId) {
            try {
                const response = await axios.get(`causes/${causeId}/`);
                this.causes[causeId] = formatCauseData(response.data);
                return this.causes[causeId];
            } catch (error) {
                console.error('Failed to load cause due to: ', error);
                throw error;
            }
        },

        /*
         * Save cause into the store.
         */
        setCauseAction(cause) {
            this.causes[cause.id] = formatCauseData(cause);
        }
    }
});

/**
 * Formats the cause data into a specific structure.
 *
 * @param {Object} cause - The cause data to format.
 * @param {number} cause.id - The unique identifier of the cause.
 * @param {string} cause.facility - The facility associated with the cause.
 * @param {string} cause.category - The category of the cause.
 * @param {string} cause.category_name - The name of the category.
 * @param {string} cause.type_of_loss - The type of loss associated with the cause.
 * @param {string} cause.name - The name of the cause.
 * @param {string} cause.code - The code of the cause.
 * @param {string} cause.description - The description of the cause.
 * @param {boolean} cause.planned - Indicates if the cause is planned.
 * @param {number} cause.target_down_time - The target down time for the cause.
 * @param {boolean} cause.equipment_failure - Indicates if the cause is due to equipment failure.
 * @param {boolean} cause.lock_transition_to_running - Indicates if the transition to running is locked.
 * @returns {Object} The formatted cause data.
 */
function formatCauseData(cause) {
    return {
        id: cause.id,
        facility: cause.facility,
        category: cause.category,
        category_name: cause.category_name,
        type_of_loss: cause.type_of_loss,
        name: cause.name,
        code: cause.code,
        description: cause.description,
        planned: cause.planned,
        target_down_time: cause.target_down_time,
        equipment_failure: cause.equipment_failure,
        lock_transition_to_running: cause.lock_transition_to_running
    };
}
